module.exports = __webpack_public_path__ + "img/info.408c06ca.svg";